import { mergeVertices } from "three/examples/jsm/utils/BufferGeometryUtils.js";
import {
  TOOTH_GUM_TYPE_KEY,
  TOOTH_PONTIC_NUM_KEY,
  TOOTH_STAGE_NUMBER_KEY,
} from "../constant/toothConstant";
import ponticDB from "../db/ponticDB";
import { modelLoad } from "../util/modelLoader";
import { addPerform } from "../../tools/perform-tool";

const ponticModelMapSingle = {};
const ponticModelListSingle = [];

const loadPonticModel = async (ponticDOList) => {
  const ponticModelPromiseList = ponticDOList.map((ponticDO) => {
    return modelLoad(ponticDO.fileUrl, ponticDO.filePath);
  });
  const ponticModelResultList = await Promise.all(ponticModelPromiseList);

  const ponticModelResultListWithNormal = ponticModelResultList.map((model) => {
    model.deleteAttribute("normal");
    const newModel = mergeVertices(model, 0.1);
    newModel.computeVertexNormals(true);
    return newModel;
  });

  return ponticModelResultListWithNormal;
};

const loadPonticModelList = async () => {
  const ponticDOList = ponticDB.getPonticDOList();
  const ponticModelResultList = await loadPonticModel(ponticDOList);

  for (let i = 0; i < ponticDOList.length; i++) {
    const ponticDO = ponticDOList[i];
    const { stageNumber, toothGumType, ponticNum } = ponticDO;

    const ponticModel = {
      stageNumber,
      toothGumType,
      ponticNum,
      model: ponticModelResultList[i],
    };

    const toothStageNumberKey = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}`;
    const toothGumTypeKey = `${TOOTH_GUM_TYPE_KEY}:${toothGumType}`;
    const ponticNumKey = `${TOOTH_PONTIC_NUM_KEY}:${ponticNum}`;

    const firstKey = `${toothStageNumberKey}`;
    const secondKey = `${ponticNumKey}.${toothGumTypeKey}`;
    const stageNumberAndGumTypeKey = `${toothStageNumberKey}.${toothGumTypeKey}`;

    if (!ponticModelMapSingle[firstKey]) {
      ponticModelMapSingle[firstKey] = {};
    }

    if (!ponticModelMapSingle[stageNumberAndGumTypeKey]) {
      ponticModelMapSingle[stageNumberAndGumTypeKey] = [];
    }

    ponticModelMapSingle[firstKey][secondKey] = ponticModel;
    ponticModelMapSingle[stageNumberAndGumTypeKey].push(ponticModel);
    ponticModelListSingle.push(ponticModel);
  }
};

const getPonticModelList = () => {
  return ponticModelListSingle;
};

const getPonticModelListByStageNumber = (stageNumber) => {
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}`;
  const ponticModelStageMap = ponticModelMapSingle[key];

  if (!ponticModelStageMap) {
    return [];
  }

  const ponticModelStageList = Object.values(ponticModelStageMap);

  return ponticModelStageList;
};

const getPonticModelListByStageNumberAndToothGumType = (
  stageNumber,
  toothGumType
) => {
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE_KEY}:${toothGumType}`;
  const ponticModelList = ponticModelMapSingle[key];

  if (!ponticModelList) {
    return [];
  }

  return ponticModelList;
};

export default {
  loadPonticModelList,
  getPonticModelListByStageNumber,
  getPonticModelListByStageNumberAndToothGumType,
  getPonticModelList,
};
